import { Box, H5, Badge, Spinner } from "@adfenix/alexandria";
import { ProgramService } from "@adfenix/types";
import { searchReadLayer } from "api/services";
import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface Props {
  programsToTrigger: ProgramService.ProgramItem[];
}

export const ProgramsToTrigger = ({ programsToTrigger }: Props) => {
  const { t } = useTranslation();

  const { hqId } = useParams<string>();

  const { data } = useQuery(["get-programs", hqId], () => {
    return searchReadLayer<ProgramService.ProgramSearchModel>({
      index: "program",
      service: "program",
      filters: programsToTrigger.map(program => {
        return { column: "id", value: program.id };
      }),
      pageSize: programsToTrigger.length
    });
  });

  if (!data) {
    return <Spinner />;
  }

  return (
    <>
      <H5 color="grey">
        {t("programBuilder.program.details.programsToTrigger.header")}
      </H5>
      {data?.documents.map(program => (
        <Box pY="xs" key={program.id}>
          <Link to={`/back-office/hq/${hqId}/program-builder/${program.id}`}>
            <Badge color="primary">{program.name}</Badge>
          </Link>
        </Box>
      ))}
    </>
  );
};
